import "../styles/locations.css";
import { useState, useEffect } from "react";
import ServiceController from "../services/service-controller";

export default function SectionLocations(props) {
  const serviceController = new ServiceController();
  const [isLoading, setIsLoading] = useState(false);
  const [residences, setrResidences] = useState([]);

  const getData = async function () {
    try {
      setIsLoading(true);
      const residencesResult = await serviceController.getResidences();
      if (residencesResult.isSuccess === false) throw residencesResult.message;
      setrResidences(residencesResult.value);
    } catch (error) {
      alert(error.toString());
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <h2 className="head">اماکن اقامتی</h2>
      <ul className="location-residences">
        {isLoading === false &&
          residences.map((item) => (
            <li>
              <a href={`/#/rooms/?city=${item.name}`}>
                <img src={item.imageUrl} loading="lazy" alt="" />
                <span>{item.name}</span>
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
}
